// Attributes coaching-invite signups: the coach-invite landing page stores the token in
// localStorage when the visitor isn't authenticated yet; as soon as they are (fresh signup
// or existing login), accept it once and clear it. Mirrors invite-claim.client.ts.
export default defineNuxtPlugin((nuxtApp) => {
  const { status } = useAuth()
  const $api = nuxtApp.$api as (url: string, opts?: any) => Promise<any>

  watch(status, async (s) => {
    if (s !== 'authenticated') return
    const token = localStorage.getItem('sm_coach_invite_token')
    if (!token) return
    // One attempt only — an expired/invalid token, or a student-role invite accepted by a
    // non-coach account, would otherwise fail forever.
    localStorage.removeItem('sm_coach_invite_token')
    try {
      await $api(`/coaching/invites/${token}/accept/`, { method: 'POST' })
    } catch (e) {
      console.error('Coaching invite accept failed:', e)
    }
  }, { immediate: true })
})
